// extracted by mini-css-extract-plugin
export default {"wrapper":"gJIF6MpeVMEdgyKXe5d_","content":"giyGZTtQl8WKNEN2jiec","viewLink":"lMtFXM0eygd_8qiDZjmX","icon":"TDT5MtKi0T64RNoHXEOE"};